import { Table } from '@surecompanies/core_components'
import ClientSelect from 'components/ClientSelect'
import React from 'react'
import ErrorComponent from '../../components/Error'
import Layout from '../../components/Layout'
import { columns } from './mapper'
import useCencusApiActivity from './useCencusApiActivity'

function CencusApiActivity() {
  const {
    data,
    refetch,
    isPending,
    isError,
    error,
    companyList,
    selectedClientId,
    handleCompanyChange,
    handlePaginationChange,
  } = useCencusApiActivity()

  // Error state
  if (isError) {
    return (
      <Layout title="Census API Activity">
        <ErrorComponent retry={refetch} error={error} />
      </Layout>
    )
  }

  return (
    <Layout title="Census API Activity">
      <ClientSelect
        allCompaniesPlacholder={{ id: '', companyName: 'All Companies' }}
        companies={companyList}
        defaultCompanyId={''}
        selectedCompanyId={selectedClientId}
        onChange={handleCompanyChange}
      />
      <Table
        loading={isPending}
        dataSource={data?.data || []}
        columns={columns as any}
        rowKey={(record) => record.id}
        locale={{
          emptyText: isPending ? 'Loading...' : 'No Data',
        }}
        pagination={{
          total: data?.meta?.total,
          showSizeChanger: false,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          current: data?.meta?.page,
          pageSize: 10,
          onChange: handlePaginationChange,
        }}
      />
    </Layout>
  )
}

export default CencusApiActivity
